import React from 'react'
import ManageItems from '../manage-form';
import ManageItemsProduct from './manage-items-product';

const ManageProduct: React.FC = () => {
    return <ManageItemsProduct title="Sản phẩm" />;
};

export default ManageProduct
